import { render, staticRenderFns } from "./HeaderTable.vue?vue&type=template&id=458d7872&scoped=true&"
import script from "./HeaderTable.vue?vue&type=script&lang=js&"
export * from "./HeaderTable.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTable.vue?vue&type=style&index=0&id=458d7872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d7872",
  null
  
)

export default component.exports